import { render, staticRenderFns } from "./DeviceUpgradeDetail.vue?vue&type=template&id=bb5a70c8&scoped=true"
import script from "./DeviceUpgradeDetail.vue?vue&type=script&lang=js"
export * from "./DeviceUpgradeDetail.vue?vue&type=script&lang=js"
import style0 from "./DeviceUpgradeDetail.vue?vue&type=style&index=0&id=bb5a70c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5a70c8",
  null
  
)

export default component.exports